export const THEMED_COLLECTION_MENU_CODE = "themed-collection";

export const ALREADY_ADDED_ARTWORK_TOOLTIP =
  "This artwork is already part of this collection and cannot be added again.";

const validateSwagNameInput = (fieldObj) => ({
  name: fieldObj.name,
  value: fieldObj.value,
});

export const SWAG_NAME_INPUT_PROPS = {
  id: "swagName",
  maxLength: 50,
  autoFocus: true,
  validate: validateSwagNameInput,
  placeholder: "e.g. New hire swag",
};

export const DEFAULT_SAVE_DRAFT_SWAG_INPUT = {
  name: "",
  colorGroupIds: [],
};
